/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon, {BaseProps} from "../Base"

const SharedUsers = (props: BaseProps) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 24 18">
      <path
        d="M12 0C14.1525 0 15.9 1.7475 15.9 3.9C15.9 6.0525 14.1525 7.8 12 7.8C9.8475 7.8 8.1 6.0525 8.1 3.9C8.1 1.7475 9.8475 0 12 0ZM3.6 2.7C5.0925 2.7 6.3 3.9075 6.3 5.4C6.3 6.8925 5.0925 8.1 3.6 8.1C2.1075 8.1 0.9 6.8925 0.9 5.4C0.9 3.9075 2.1075 2.7 3.6 2.7ZM0 15C0 12.3487 2.14875 10.2 4.8 10.2C5.28 10.2 5.745 10.2712 6.18375 10.4025C4.95 11.7825 4.2 13.605 4.2 15.6V16.2C4.2 16.6275 4.29 17.0325 4.45125 17.4H1.2C0.53625 17.4 0 16.8637 0 16.2V15ZM19.5487 17.4C19.71 17.0325 19.8 16.6275 19.8 16.2V15.6C19.8 13.605 19.05 11.7825 17.8163 10.4025C18.255 10.2712 18.72 10.2 19.2 10.2C21.8513 10.2 24 12.3487 24 15V16.2C24 16.8637 23.4638 17.4 22.8 17.4H19.5487ZM17.7 5.4C17.7 3.9075 18.9075 2.7 20.4 2.7C21.8925 2.7 23.1 3.9075 23.1 5.4C23.1 6.8925 21.8925 8.1 20.4 8.1C18.9075 8.1 17.7 6.8925 17.7 5.4ZM6 15.6C6 12.285 8.685 9.6 12 9.6C15.315 9.6 18 12.285 18 15.6V16.2C18 16.8637 17.4638 17.4 16.8 17.4H7.2C6.53625 17.4 6 16.8637 6 16.2V15.6Z"
        fill="#000"
      />
    </BaseSvgIcon>
  )
}

export default SharedUsers
